import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyA6F8pjHCr2oEhzqhYD_-9flq7Q-qrMP2Q",
  authDomain: "indiantrade-billing.firebaseapp.com",
  databaseURL: "https://indiantrade-billing-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "indiantrade-billing",
  storageBucket: "indiantrade-billing.firebasestorage.app",
  messagingSenderId: "624997290028",
  appId: "1:624997290028:web:3e8d44bd6fec0424c50189"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const database = getDatabase(app);